<template>
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 0C3.81291 0 0 3.81291 0 8.5C0 13.1871 3.81291 17 8.5 17C13.1871 17 17 13.1871 17 8.5C17 3.81291 13.1871 0 8.5 0Z" fill="#0ACF97"/>
<path d="M12.808 6.69882L8.20374 11.3029C8.06561 11.441 7.88429 11.5106 7.70297 11.5106C7.52165 11.5106 7.34033 11.441 7.2022 11.3029L4.90016 9.00086C4.62312 8.72395 4.62312 8.27623 4.90016 7.99932C5.17707 7.72228 5.62466 7.72228 5.9017 7.99932L7.70297 9.80059L11.8064 5.69728C12.0833 5.42024 12.5309 5.42024 12.808 5.69728C13.0849 5.97419 13.0849 6.42178 12.808 6.69882Z" fill="#FAFAFA"/>
</svg>


</template>

<script>
export default {

}
</script>

<style>

</style>